type GuardFn<T> = (value: T) => boolean | undefined;

/**
 * return array of errors from a map for ErrorMessage -> ValidatorFn
 */
export function errorsValidtorMap<TValue extends any>(map: Record<string, GuardFn<TValue>>) {
  return function (value: NoInfer<TValue>): string[] {
    return Object.entries(map)
      .map(([errorMessage, validator]) => ([errorMessage, Boolean(validator(value))] as const))
      .filter(([_, isInvalid]) => isInvalid)
      .map(([msg]) => msg);
  }
}

/**
 * custom made for @tanstack/form
 * return the first error from a map for ErrorMessage -> ValidatorFn
 */
export function errorValidtorMap<TValue extends any>(map: Record<string, GuardFn<TValue>>) {
  return function ({ value }: { value: NoInfer<TValue> }): string | undefined {
    return Object.entries(map)
      .find(([_, validator]) => Boolean(validator(value)))?.[0];
  }
}
